import getEnv from '@/plugins/getEnv'
import { FileManagerFile } from '@/models'

export default function getFileURL(file?: FileManagerFile) {
  if (!file) return undefined
  if (file.externalUrl) return file.externalUrl
  const endpoint = getEnv('VUE_APP_S3_ENDPOINT') || `https://s3.amazonaws.com`
  return getEnv('VUE_APP_S3_PUBLIC_URL')
    ? `${getEnv('VUE_APP_S3_PUBLIC_URL')}/${file.key}`
    : `${endpoint}/${file.bucket}/${file.key}`
}
